// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_3w8kUfsIZttE4ZoXSncuJU","modalButtons":"_3AXdR3oKFF4-H31CyaI3du"};